import React, { Component } from 'react'
import styled from 'styled-components'
import { Modal, TextInput, Button } from 'advenio-components'
import Rating from './Rating'
import { Form } from 'formsy-react' //eslint-disable-line

const Header = styled.div`
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  display: flex;
  margin-top: 8px;
`

const CloseButton = styled.img`
  position: absolute;
  right: 16px;
  top:8px;
  width: 20px;
`

const HeaderTitle = styled.span`
  font-size: 12px;
  width: 130px;
`
const CenterTitle = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`

const Body = styled.div`
  margin-top:16px;
  display: flex;
  justify-content: center;
  padding: 8px;
`

class RatingModal extends Component {
  state = {
    currentRating: 0,
    currentRatingTeacher:0
  }

  handleRatingChange = (rating) => {
    this.setState({ currentRating: rating })
  }
  handleRatingChangeTeacher = (rating) => {
    this.setState({ currentRatingTeacher: rating })
  }
  submitRating = (data) => {
    const { latest_health_check: { registered_by } ,id } = this.props.child
    const { comments = null, commentsTeacher = null} = data
    const rating = this.rating.getValue()
    const ratingTeacher = this.ratingTeacher.getValue()
    const center_id = this.props.child.center.id
    const user_id = registered_by
    const student_id = id
    const infoToSend = { commentsTeacher,comments,user_id , rating, ratingTeacher, center_id, student_id }
    this.props.submit(infoToSend)
  }
  handleClose = () => {
    const { onClose } = this.props
    this.setState({
      currentRating: 0,
    }, () => onClose && onClose())
  }
  render() {
    const { currentRating, currentRatingTeacher } = this.state
    const { open, loading, child } = this.props
    return (
      <Modal
        isOpened={open}
        onClose={this.handleClose}
        statePath="parent_platform_rating"
        actionType="rating"
        typePrefix="PARENT_PLATFORM_RATING"
      >
        <Header>
          <HeaderTitle>
            ¿Cómo calificas nuestro servicio el día de hoy?
          </HeaderTitle>
          <CloseButton src="/assets/Close.svg" onClick={this.handleClose} />
        </Header>
        <Body>
          <Form onSubmit={this.submitRating}>
            <CenterTitle>
              Calificación Centro &nbsp;<b>{child && `${child.center.name} ${child.center.abbreviation}`}</b>
            </CenterTitle>
            <Rating
              ref={(rating) => { this.rating = rating }}
              onRatingChange={rating => this.handleRatingChange(rating)}
            />
            <TextInput
              name="comments"
              label="Observaciones para centro"
              textarea
            />
            <br/>
            <CenterTitle>
              Calificación Formadora &nbsp;<b>{child.latest_health_check && child.latest_health_check.registered_name}</b>
            </CenterTitle>
            <Rating
              ref={(ratingTeacher) => { this.ratingTeacher = ratingTeacher }}
              onRatingChange={ratingTeacher => this.handleRatingChangeTeacher(ratingTeacher)}
            />
            <TextInput
              name="commentsTeacher"
              label="Observaciones para Formada"
              textarea
            />
            <Button
              success
              type="submit"
              fullWidth
              disabled={currentRating === 0 || currentRatingTeacher === 0}
              loading={loading}
            >
              Enviar Calificacion
            </Button>
          </Form>
        </Body>
      </Modal>
    )
  }
}


export default RatingModal



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/RatingModal/index.jsx